<template>
    <div class="opac-wrapper">
        <header class="header">
            <div class="loginStatus r">
                <div class="unLogin l" @click="toPerson" v-show="(user==null || user=='') && !authorizedLogin" >
                    <img src="../../assets/images/staticUserLogo.png" alt="头像">
                    <span>请登录</span>
                </div>
                <div class="logined l" v-show="user!=null" @click="toPerson">
                    <div class="headerImg">
                        <img v-if="readerData.image" :src="imgPath+readerData.image" alt="头像">
                        <img v-else  src="../../assets/images/staticUserLogo.png" alt="头像">
                    </div>
                    <div class="username" :title="user&&user.cardName.length>4?user.cardName:''">{{user?user.cardName.slice(0,4):''}}</div>
                    <div class="newNum" v-show="count>0">{{count}}</div>
                </div>
            </div>
        </header>
        <div class="libName">
            <h2><img  class="opac-logo" v-if="logoUrl" :src="imgPath+logoUrl"><span>{{libraryName}}</span></h2>
        </div>
        <section class="search">
            <div class="searchWrapper">
                <div class="selectWrapper l">
                    <div class="chooseInput">
                        <div class="chooseHeader"  @click="toggleList" v-on-clickaway="hideList">
                            <input type="text" class="keyWord ellip" disabled="disabled" v-model="select.desc" ref="input"/>
                            <div class="chooseIco"></div>
                        </div>
                        <ul v-if="selectShow" @mouseenter="stopScroll" @mouseleave="canedScroll" ref="list" class="list">
                            <li class="dot ellip" :key="item.desc" v-for="item in list" @click="selectValueHandle(item)">{{item.desc}}</li>
                        </ul>
                    </div>
                </div>
                <input type="text" placeholder="请输入搜索关键字" v-model="keyword" maxlength="30px" class="searchInput l"/>
                <div class="searchBtn themeBg" @click="search">搜索</div>
            </div>
            <div class="highSearch themeColor" @click="seniorSearch" v-if="select.desc!='活动'">高级搜索</div>
        </section>
        <section class="OPac-main">
            <ul class="OPac-ul">
                <li v-for="(item, index) in navList" :key="index" :class="item.background" @click="handleSkip(item.name,item.url)">
                    <p class="desc">{{item.name}}</p>
                </li>
            </ul>
        </section>
    </div>
</template>

<script>
    import {directive as onClickaway} from 'vue-clickaway';
    import {ajaxUtil} from '../../common/AjaxUtil';
    import {store} from '../../store/store';
    import {api,imgPath} from '../../common/config.js';
    import {CommonUtil} from '../../common/CommonUtil';
    import {StorageUtil} from '../../common/Auth';
    import Select from '../../components/select';
    import $ from 'jquery'

    export default {
        name: "OPACIndex",
        data(){
            return {
                imgPath:imgPath,
                isLogo:false,
                select: {desc: '图书'},
                list: [{desc: '图书'}, {desc: '电子书'}, {desc: '资讯'}, {desc: '活动'}],
                activeRouteName: '首页',
                keyword:'',
                canScroll: true,
                selectShow: false,
                libCode:'',
                currAreaDesc: "",
                currAreaCode: "",
                user: null,
                authorizedLogin: false,//是否是授权登录方式
                readerData: {image: "", idCard: "", phone: ""},
                imgError: store.imgError_headerIco,
                messageCount: 0,
                unreadCount: 0,
                logoUrl:"",
                latLng: store.localtionArea ? "104.0658,30.65734" : store.localtionArea.latLng,
            }
        },
        directives: {
            onClickaway: onClickaway,
        },
        components: {
            Select,
        },
        computed: {
            count() {
                return this.messageCount + this.unreadCount
            },
            libId() {
              let id='';
              if(store.library.libId && !this.$route.query.libId){
                id = store.library.libId
              }
              if(this.$route.query.libId){
                id =this.$route.query.libId
              }
              return id
            },
            libLevel() {
                return store.library.libLevel || '';
            },
            hallCode() {
                return this.$route.query.hallCode || '';
            },
            navList() {
                return store.menu.slice(1);
            },
            libraryName(){
                return this.$route.query.libraryname || '';
            },
            fromSearch() {
                return this.$route.query.fromSearch || 0;
            },
            lngLat(){
                return this.$route.query.latLng || store.localtionArea.latLng || '';
            },
        },
        watch:{
            'user':{
                handler(){
                    if(StorageUtil.getObject("user")){
                        this.readerData = StorageUtil.getObject("user");
                    }
                },
                deep:true
            }
        },
        created() {
            if(store.wrap){
                this.unreadCount = store.wrap.unreadCount;
                this.messageCount = store.wrap.messageCount;
            }
            store.wrap = this;
            if (StorageUtil.getString("authorizedLogin")) {
                this.authorizedLogin = true;
            }
        },
        async beforeMount() {
            let u = CommonUtil.getHashParams();
            let tk = u.access_token;
            if (tk != undefined && tk != null && tk != '') {
                StorageUtil.storeString("authorizedLogin", true);
                this.authorizedLogin = true;
            }
            await this.getUser();
            store.token = !StorageUtil.getString("token") ? '' : StorageUtil.getString("token");
            store.user = !StorageUtil.getObject("user") ? '' : StorageUtil.getObject("user");
            this.user = store.func.getUserObj();
            //定位设置
            if (StorageUtil.getObject("localtionArea") != null) {
                store.localtionArea = StorageUtil.getObject("localtionArea");
            }
            if (StorageUtil.getObject("choosedCitys") != null) {
                store.choosedCitys = StorageUtil.getObject("choosedCitys");
            }
            if (StorageUtil.getObject("chooseArea") == null) {
                store.chooseArea = StorageUtil.getObject("chooseArea");
                setTimeout(this.initLocationFunc, 2000);
            } else {
                store.chooseArea = StorageUtil.getObject("chooseArea");
                this.currAreaDesc = store.chooseArea.desc;
                this.currAreaCode = store.chooseArea.code;
            }
        },
        mounted(){
            this.getAllNum();
            this.getIndroduce();
            //阻止返回到屏保
            if (window.history && window.history.pushState) {
                // 向历史记录中插入了当前页
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate', this.goBack, false);
            }
        },
        destroyed () {
            window.removeEventListener('popstate', this.goBack, false);
        },
        methods:{
            /**获取简介**/
            getIndroduce(){
                let url = api.library.info.replace('{fromSearch}', this.fromSearch).replace('{flag}',1).replace('{libId}', this.libId).replace('{lngLat}', this.lngLat);
                ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                  console.log(data.info.logo)
                    this.logoUrl = data.info.logo;
                    this.libraryInfoData = data;
                }, null, this);
            },
            search(){
                var keyword = this.keyword;
                if (keyword.trim() == "") {
                    this.keyword = "";
                    $('.searchInput').focus();
                    return;
                }
                var type = -1;
                var searchType = this.select.desc;
                if (searchType === "图书") {
                    type = 1;
                } else if (searchType === "电子书") {
                    type = 2;
                } else if (searchType === "图书馆") {
                    type = 3;
                } else if (searchType === "活动") {
                    type = 4;
                } else if (searchType === "资讯") {
                    type = 5;
                }
                this.$router.push({
                    path: 'indexsearch',
                    query: {searchStr: keyword, type: type, code: store.chooseArea.code, fromSearch: 0, hallCode: this.libCode}
                });
            },
            //高级搜索
            seniorSearch: function () {
                var searchType = this.select.desc;
                if (searchType === "图书") {
                    this.$router.push({path: '/searchbook', query: {fromSearch: 0, hallCode: this.libCode, typeId:0 }});
                } else if (searchType === "电子书") {
                    this.$router.push({path: '/searchbook', query: {fromSearch: 0, hallCode: this.libCode, typeId:1 }});
                } else if (searchType === "图书馆") {
                    this.$router.push({path: '/searchlibrary', query: {fromSearch: 0, hallCode: this.libCode}});
                } else if (searchType === "资讯") {
                    this.$router.push({path: '/searchbook', query: {fromSearch: 0, hallCode: this.libCode, typeId:2 }});
                }
            },
            stopScroll(ev) {
                this.canScroll = false;
            },
            canedScroll() {
                this.canScroll = true;
            },
            selectValueHandle(val) {
                this.selectShow = false; //隐藏下拉框
                this.select = val;
            },
            toggleList(){
                if (!this.selectShow) {
                    this.selectShow = true;
                } else if (this.selectShow) {
                    this.selectShow = false;
                }
            },
            showList() { // 组件外打开下拉框方法
                if (!this.isChange) {
                    setTimeout(() => {
                        this.selectShow = true;
                    })
                }
            },
            hideList() {
                this.selectShow = false;
            },
            handleSkip(name,url){
                if (name == '学习强国') {
                    window.location = 'https://www.xuexi.cn'
                }
                this.$router.push(url);
            },
            //    获取读者信息
            async getUser() {
                var url = api.auth.ticket;
                if (!this.$route.query.ssoid || store.user) {
                    return false
                };
                var data = {ssoid: this.$route.query.ssoid};
                await ajaxUtil.ajaxJson(url, data, "POST", (data) => {
                    store.user = data.reader;
                    store.token = data.token;
                    StorageUtil.storeString('token', data.token);
                    StorageUtil.storeObject('user',data.reader);
                    CommonUtil.setCookie("loginStart", "true", 0.375);//0.375
                    CommonUtil.setCookie("noMovingTime", "true", 0.125);//0.125
                }, (error) => {
                }, this)
            },
            initLocationFunc() {
                this.currAreaDesc = store.chooseArea.desc;
                this.currAreaCode = store.chooseArea.code;
                this.latLng = store.localtionArea.latLng;
            },
            getAllNum() {
                //未读消息量
                if (!this.user) {
                    return false
                }
                var url = api.personalnews.overdue.replace('{idCard}', this.user.idCard);
                ajaxUtil.ajaxJson(url, null, 'GET', (data) => {
                    this.messageCount = data.messageCount;
                }, null, this)
                var otherNewsUrl = api.personal.getUnreadcount;
                ajaxUtil.ajaxJson(otherNewsUrl, {readerId: this.user.readerId}, 'POST', (data) => {
                    this.unreadCount = data.unreadCount
                }, null, this)
            },
            toPerson() {
                if (this.user != null) {
                    this.$router.push({path: '/apply', query: {hallCode: this.hallCode}});
                } else {
                    store.index.$refs.login.showLogin();
                }
            },
            //阻止返回到屏保
            goBack () {
                history.pushState(null, null, document.URL);
            },
        }
    }
</script>

<style scoped lang="sass">
    .opac-wrapper
        width: 100%
        min-height: 100%
        background: #f6f6f6
        position: relative
        .header
            height: 60px
            width: 100%
            background: #fdfeff
            box-shadow: 0px 4px 6px 0 rgba(0, 0, 0, 0.04)
            text-align: center
            .loginStatus
                position: absolute
                top: 0px
                right: 53px
                height: 60px
                line-height: 60px
                color: #bb6b32
                font-size: 16px
                cursor: pointer
                img
                    margin-right: 14px
                    width: 25px
                    height: 25px
                    border-radius: 6px !important
                    vertical-align: middle
                .logined
                    position: relative
                    .headerImg
                        float: left
                    .newNum
                        position: absolute
                        top: 10px
                        right: -11px
                        width: 15px
                        height: 15px
                        border-radius: 8px
                        font-size: 12px
                        text-align: center
                        line-height: 15px
                        color: #fff
                        background: #ff0000
                    .username
                        float: left
                        height: 60px
                    &:hover
                        color: $themecolor1
        .libName
             margin-top: 90px
             h2
                 font-size: 56px
                 display: flex
                 justify-content: center
                 align-items: center
                 .opac-logo
                     width: 64px
                     margin-right: 10px
        .search
            width: 1200px
            height: 200px
            margin: 106px auto 0
        .searchWrapper
            width: 100%
            height: 80px
            margin-bottom: 42px
        .selectWrapper
            box-sizing: border-box
            width: 200px
            height: 100%
            margin-left: 1px
            padding-right: 1px
            border: 1px solid #ccc
            border:
                right: none
            background: #fff url("../../assets/images/mainSelectBg.png") right center no-repeat

        .searchInput
            width: 798px
            height: 100%
            font-size: 30px
            text-indent: 30px
            border: 1px solid #ccc
            border:
                left: none
                right: none

        .searchBtn
            box-sizing: border-box
            overflow: hidden
            height: 100%
            text-align: center
            line-height: 80px
            font-size: 30px
            letter-spacing: 10px
            text-indent: 10px
            color: #fff
            cursor: pointer

        .highSearch
            width: 120px+19px+32px
            height: 30px
            padding-right: 20px
            margin: 0 auto
            font-size: 30px
            line-height: 30px
            background: url("../../assets/images/opac-s.png") no-repeat right center
            background-size: 30px 30px
            cursor: pointer
        .chooseInput
            position: relative
            width: 100%
            height: 100%
            box-sizing: border-box
        .chooseHeader
            box-sizing: border-box
            position: absolute
            top: 0px
            left: 0
            width: 100%
            height: 100%
            cursor: pointer
        .chooseHeader input
            box-sizing: border-box
            vertical-align: top
            padding-right: 30px
            width: 100%
            height: 100%
            border: none
            text-indent: 30px
            font-size: 30px
            cursor: pointer
            pointer-events: none
        .chooseIco
            position: absolute
            top: 50%
            right: 19px
            margin-top: -4px
            width: 20px
            height: 12px
            background: url("../../assets/images/opac-arrow.png") no-repeat
        .list
            box-sizing: border-box
            position: absolute
            top: 81px
            left: -1px
            width: 100%
            background: #fff
            z-index: 99
            overflow: auto
            max-height: 320px
            cursor: pointer
        .list li
            box-sizing: border-box
            height: 80px
            width: 100%
            line-height: 80px
            font-size: 30px
            text-indent: 30px

        .list li:hover
            background: #fee1cd
            color: #bb6b32

        input:disabled
            color: #333
            border: none !important
            background: #fff !important
            user-select: none
            -ms-user-select: none
        .OPac-main
            width: 1200px
            margin: 0 auto
            height: auto
        .OPac-ul
            width: 100%
            clear: both
            height: auto
            li
                width: 180px
                height: 180px
                float: left
                border-radius: 10px
                margin-right: 75px
                text-align: center
                font-size: 26px
                color: #7e3c00
                cursor: pointer
                &:nth-of-type(5)
                    margin-right: 0
                &:nth-of-type(n+6)
                    margin-top: 75px
                .desc
                    margin-top: 123px
            .bg-book
                background: #fff url('../../assets/images/lib-icon-book.png') no-repeat center 33px
            .bg-ebook
                background: #fff url('../../assets/images/lib-icon-ebook.png') no-repeat center 33px
            .bg-news
                background: #fff url('../../assets/images/lib-icon-news.png') no-repeat center 33px
            .bg-activity
                background: #fff url('../../assets/images/lib-icon-act.png') no-repeat center 33px
            .bg-reader
                background: #fff url('../../assets/images/lib-icon-message.png') no-repeat center 33px
            .bg-indroduce
                background: #fff url('../../assets/images/lib-icon-bgjs-selected.png') no-repeat center 33px
            .bg-library
                background: #fff url('../../assets/images/lib-icon-zfg.png') no-repeat center 33px
            .bg-learnpower
                background: #fff url('../../assets/images/learn-power-logo02.png') no-repeat center 33px
    .web2
        .username
            &:hover
                color: $themecolor2!important
</style>
